


































import _ from "lodash";
import rest from "@/rest";
import { Component, Vue } from "vue-property-decorator";
import { EmailQueueEntryVm } from "@/interfaces/EmailQueueEntryVm";

@Component
export default class EmailQueue extends Vue {
  searchValue = "";
  showOnlyNotSendEmails = false;
  queue: EmailQueueEntryVm[] = [];

  // $refs!: {};

  headers = [
    { text: "Zugefügt",value: "enqueueDate",sortable: true },
    { text: "Versand", value: "sendDate",sortable: true },
    { text: "Meldung", align: "left", value: "loggingMessage", sortable: true },
    { text: "Wiederholungen", value: "retryCount",sortable: true },
    { text: "Priorität", value: "sendWithPriority",sortable: true },
  ];

  mounted() {
    this.updateQueue();
  }

  async onSearchChanged() {
    await this.updateQueue();
  }

  async onShowOnlyNotSendEmails() {
    await this.updateQueue();
  }

  async updateQueue() {
    this.queue = await rest.url("admin/getEmailQueueEntries").query({ search: this.searchValue ?? "", showOnlyNotSendEmails : this.showOnlyNotSendEmails }).get();
  }
}
